import React from 'react';
import './components/ReactConnectWPElements';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { setupFetchInterceptor } from './utils/fetchInterceptor';
import './i18n';
import './styles/index.css';

setupFetchInterceptor();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );